import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { EnumPicker, DatePicker, PausedUpdatesPicker, ListPicker, HistoricallyPausedUpdatesPicker, InputListPicker, PropertyPicker, } from './filter/FilterPickers.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import { DateDisplay, EnumDisplay, InputListDisplay, ListDisplay, PausedUpdatesDisplay, PropertyDisplay, } from './filter/FilterDisplay.js';
import { CreditorState } from '@debbie/common/dist/creditor/index.js';
import { Direction, InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { Currency } from '@debbie/common/dist/index.js';
import { CaseVoucherSource, State, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { PausedUpdatesFilterTypePicker, DateFilterTypePicker, InFilterTypePicker, NotImplementedFilterTypePicker, } from './filter/FilterTypePickers.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import { useUpdateTypes } from '@debbie/cortex/dist/update-types/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { objectBy, uniqueBy } from '@debbie/common/dist/util/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import { useTeams } from '@debbie/cortex/dist/teams/index.js';
import { UserState } from '@debbie/common/dist/users/index.js';
export const filters = {
    caseStatus: {
        key: 'caseStatus',
        label: (lang) => lang.viewFilterTypeLabels.caseStatus,
        icon: 'activity',
        picker: EnumPicker('caseStatus', 'cases.status', Object.values(CaseStatus).map((cs) => ({
            value: cs,
            label: (lang) => lang.cases.caseStatus[cs],
        }))),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('cases.status', Object.values(CaseStatus).map((cs) => ({
            value: cs,
            label: (lang) => lang.cases.caseStatus[cs],
        }))),
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    creditorId: {
        key: 'creditorId',
        label: (lang) => lang.viewFilterTypeLabels.creditorId,
        icon: 'users',
        picker: ListPicker('creditorId', 'creditors.creditorId', useAllCreditors, (c) => c.creditorId, (c) => c.name),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useAllCreditors, (c) => c.creditorId, (c) => c.name),
        displayGroup: (lang) => lang.caseFilter.creditorsGroup,
    },
    creditorState: {
        key: 'creditorState',
        label: (lang) => lang.viewFilterTypeLabels.creditorState,
        icon: 'list',
        picker: EnumPicker('creditorState', 'creditors.state', Object.values(CreditorState).map((s) => {
            return {
                value: s,
                label: (lang) => lang.creditorStateDescriptions[s],
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('creditors.state', Object.values(CreditorState).map((s) => {
            return {
                value: s,
                label: (lang) => lang.creditorStateDescriptions[s],
            };
        })),
        displayGroup: (lang) => lang.caseFilter.creditorsGroup,
    },
    interactionDirection: {
        key: 'interactionDirection',
        label: (lang) => lang.viewFilterTypeLabels.interactionDirection,
        icon: 'mail',
        picker: EnumPicker('interactionDirection', 'interactions.direction', Object.values(Direction).map((d) => ({
            value: d,
            label: (lang) => lang.interactions[d],
        }))),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('interactions.direction', Object.values(Direction).map((d) => ({
            value: d,
            label: (lang) => lang.interactions[d],
        }))),
        displayGroup: (lang) => lang.caseFilter.interactionsGroup,
    },
    interactionType: {
        key: 'interactionType',
        label: (lang) => lang.viewFilterTypeLabels.interactionType,
        icon: 'mail',
        picker: EnumPicker('interactionType', 'interactions.type', Object.values(InteractionType).map((type) => {
            return {
                value: type,
                label: (lang) => lang.interactionTypes[type],
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('interactions.type', Object.values(InteractionType).map((type) => {
            return {
                value: type,
                label: (lang) => lang.interactionTypes[type],
            };
        })),
        displayGroup: (lang) => lang.caseFilter.interactionsGroup,
    },
    caseVoucherState: {
        key: 'caseVoucherState',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherState,
        icon: 'list',
        picker: EnumPicker('caseVoucherState', 'caseVouchers.state', Object.values(State).map((state) => {
            return {
                value: state,
                label: (lang) => lang.caseVoucherStates[state],
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('caseVouchers.state', Object.values(State).map((state) => {
            return {
                value: state,
                label: (lang) => lang.caseVoucherStates[state],
            };
        })),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    caseVoucherSource: {
        key: 'caseVoucherSource',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherSource,
        icon: 'list',
        picker: EnumPicker('caseVoucherSource', 'caseVouchers.source', Object.values(CaseVoucherSource).map((source) => {
            return {
                value: source,
                label: (lang) => lang.caseVoucherSources[source],
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('caseVouchers.source', Object.values(CaseVoucherSource).map((source) => {
            return {
                value: source,
                label: (lang) => lang.caseVoucherSources[source],
            };
        })),
        displayGroup: (lang) => lang.caseFilter.creditorsGroup,
    },
    caseVoucherCurrency: {
        key: 'caseVoucherCurrency',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherCurrency,
        icon: 'list',
        picker: EnumPicker('caseVoucherCurrency', 'caseVouchers.currency', Object.values(Currency).map((currency) => {
            return {
                label: (lang) => currency,
                value: currency,
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('caseVouchers.currency', Object.values(Currency).map((currency) => {
            return {
                label: (lang) => currency,
                value: currency,
            };
        })),
        displayGroup: (lang) => lang.caseFilter.creditorsGroup,
    },
    pausedWithUpdates: {
        key: 'pausedWithUpdates',
        label: (lang) => lang.viewFilterTypeLabels.pausedWithUpdates,
        icon: 'paused',
        picker: PausedUpdatesPicker,
        typePicker: PausedUpdatesFilterTypePicker,
        display: PausedUpdatesDisplay,
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
    historicallyPausedUpdates: {
        key: 'historicallyPausedUpdates',
        label: (lang) => lang.viewFilterTypeLabels.historicallyPausedUpdates,
        icon: 'paused',
        picker: HistoricallyPausedUpdatesPicker,
        typePicker: PausedUpdatesFilterTypePicker,
        display: PausedUpdatesDisplay,
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
    creditorCreatedAt: {
        key: 'creditorCreatedAt',
        label: (lang) => lang.viewFilterTypeLabels.creditorCreatedAt,
        icon: 'calendar',
        picker: DatePicker('creditorCreatedAt', 'creditors.createdAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('creditors.createdAt'),
        displayGroup: (lang) => lang.caseFilter.creditorsGroup,
    },
    updatePausedAt: {
        key: 'updatePausedAt',
        label: (lang) => lang.viewFilterTypeLabels.updatePausedAt,
        icon: 'calendar',
        picker: DatePicker('updatePausedAt', 'updates.pausedAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('updates.pausedAt'),
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
    updateContinuedAt: {
        key: 'updateContinuedAt',
        label: (lang) => lang.viewFilterTypeLabels.updateContinuedAt,
        icon: 'calendar',
        picker: DatePicker('updateContinuedAt', 'updates.continuedAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('updates.continuedAt'),
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
    updateRemindedAt: {
        key: 'updateRemindedAt',
        label: (lang) => lang.viewFilterTypeLabels.updateRemindedAt,
        icon: 'calendar',
        picker: DatePicker('updateRemindedAt', 'updates.remindedAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('updates.remindedAt'),
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
    caseCreatedAt: {
        key: 'caseCreatedAt',
        label: (lang) => lang.viewFilterTypeLabels.caseCreatedAt,
        icon: 'calendar',
        picker: DatePicker('caseCreatedAt', 'cases.createdAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('cases.createdAt'),
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    caseVoucherDate: {
        key: 'caseVoucherDate',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherDate,
        icon: 'calendar',
        picker: DatePicker('caseVoucherDate', 'caseVouchers.date'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('caseVouchers.date'),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    caseVoucherExpirationDate: {
        key: 'caseVoucherExpirationDate',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherExpirationDate,
        icon: 'calendar',
        picker: DatePicker('caseVoucherExpirationDate', 'caseVouchers.expirationDate'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('caseVouchers.expirationDate'),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    caseVoucherIrrecoverableDate: {
        key: 'caseVoucherIrrecoverableDate',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherIrrecoverableDate,
        icon: 'calendar',
        picker: DatePicker('caseVoucherIrrecoverableDate', 'caseVouchers.irrecoverableDate'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('caseVouchers.irrecoverableDate'),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    caseVoucherCreatedAt: {
        key: 'caseVoucherCreatedAt',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherCreatedAt,
        icon: 'calendar',
        picker: DatePicker('caseVoucherCreatedAt', 'caseVouchers.createdAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('caseVouchers.createdAt'),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    satisfactionCreatedAt: {
        key: 'satisfactionCreatedAt',
        label: (lang) => lang.viewFilterTypeLabels.satisfactionCreatedAt,
        icon: 'calendar',
        picker: DatePicker('satisfactionCreatedAt', 'satisfactions.satisfiedAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('satisfactions.satisfiedAt'),
        displayGroup: (lang) => lang.caseFilter.contactsGroup,
    },
    interactionCreatedAt: {
        key: 'interactionCreatedAt',
        label: (lang) => lang.viewFilterTypeLabels.interactionCreatedAt,
        icon: 'calendar',
        picker: DatePicker('interactionCreatedAt', 'interactions.createdAt'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('interactions.createdAt'),
        displayGroup: (lang) => lang.caseFilter.interactionsGroup,
    },
    endReasonId: {
        key: 'endReasonId',
        label: (lang) => lang.viewFilterTypeLabels.endReasonId,
        icon: 'list',
        picker: ListPicker('endReasonId', 'cases.endReasonId', useEndReasons, (er) => er.id, (er, lang) => lang.endReason[er.handle] ?? er.label),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useEndReasons, (er) => er.id, (er, lang) => lang.endReason[er.handle] ?? er.label),
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    caseGroupId: {
        key: 'caseGroupId',
        label: (lang) => lang.viewFilterTypeLabels.caseGroupId,
        icon: 'list',
        picker: ListPicker('caseGroupId', 'cases.caseGroupId', useCaseGroups, (cg) => cg.id, (cg) => cg.label),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useCaseGroups, (cg) => cg.id, (cg) => cg.label),
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    caseVoucherType: {
        key: 'caseVoucherType',
        label: (lang) => lang.viewFilterTypeLabels.caseVoucherType,
        icon: 'list',
        picker: ListPicker('caseVoucherType', 'caseVouchers.voucherTypeId', () => {
            const types = useVoucherTypes();
            if (h.hasData(types)) {
                return {
                    ...types,
                    data: types.data.filter((t) => CaseVoucherCategories.includes(t.category)),
                };
            }
            return types;
        }, (vt) => vt.voucherTypeId, (vt, lang) => lang.economyVoucherTypeLabels[vt.voucherTypeId] ?? vt.label),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useVoucherTypes, (vt) => vt.voucherTypeId, (vt, lang) => lang.economyVoucherTypeLabels[vt.voucherTypeId] ?? vt.label),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    billingModelId: {
        key: 'billingModelId',
        label: (lang) => lang.viewFilterTypeLabels.billingModelId,
        icon: 'list',
        picker: ListPicker('billingModelId', 'billingModels.billingModelId', useBillingModels, (bm) => bm.billingModelId, (bm) => bm.name),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useBillingModels, (bm) => bm.billingModelId, (bm) => bm.name),
        displayGroup: (lang) => lang.caseFilter.economyGroup,
    },
    documentType: {
        key: 'documentType',
        label: (lang) => lang.viewFilterTypeLabels.documentType,
        icon: 'list',
        picker: EnumPicker('documentType', 'documents.type', Object.values(DocumentTypes).map((t) => {
            return {
                label: (lang) => lang.documentTypes[t],
                value: t,
            };
        })),
        typePicker: InFilterTypePicker,
        display: EnumDisplay('documents.type', Object.values(DocumentTypes).map((t) => {
            return {
                label: (lang) => lang.documentTypes[t],
                value: t,
            };
        })),
        displayGroup: (lang) => lang.caseFilter.documentsGroup,
    },
    caseWorkflow: {
        key: 'caseWorkflow',
        label: (lang) => lang.viewFilterTypeLabels.caseWorkflow,
        icon: 'workflow',
        picker: ListPicker('caseWorkflow', 'cases.workflowId', useWorkflows, (w) => w.workflowId, (w) => w.title),
        typePicker: InFilterTypePicker,
        display: ListDisplay(useWorkflows, (w) => w.workflowId, (w) => w.title),
        displayGroup: (lang) => lang.caseFilter.workflowsGroup,
    },
    currentCaseWorkflowTask: {
        key: 'currentCaseWorkflowTask',
        label: (lang) => lang.viewFilterTypeLabels.currentCaseWorkflowTask,
        icon: 'workflow',
        picker: ListPicker('currentCaseWorkflowTask', 'cases.workflowCurrentTaskId', () => {
            const workflowsLoader = useWorkflows();
            const updateTypesLoader = useUpdateTypes();
            if (h.hasData(workflowsLoader)) {
                const updateTypeLookup = h.hasData(updateTypesLoader)
                    ? objectBy(updateTypesLoader.data, (ut) => ut.updateTypeId)
                    : {};
                return {
                    ...workflowsLoader,
                    data: uniqueBy(workflowsLoader.data.flatMap((wf) => wf.tasks.map((t) => ({
                        ...t,
                        updateType: updateTypeLookup[t.updateTypeId] ?? undefined,
                    }))), (t) => t.id),
                };
            }
            return workflowsLoader;
        }, (t) => t.id, (t, lang) => lang.updateTypes[t.updateTypeId] ?? t.updateType?.label ?? ''),
        typePicker: InFilterTypePicker,
        display: ListDisplay(() => {
            const workflowsLoader = useWorkflows();
            const updateTypesLoader = useUpdateTypes();
            if (h.hasData(workflowsLoader)) {
                const updateTypeLookup = h.hasData(updateTypesLoader)
                    ? objectBy(updateTypesLoader.data, (ut) => ut.updateTypeId)
                    : {};
                return {
                    ...workflowsLoader,
                    data: uniqueBy(workflowsLoader.data.flatMap((wf) => wf.tasks.map((t) => ({
                        ...t,
                        updateType: updateTypeLookup[t.updateTypeId] ?? undefined,
                    }))), (t) => t.id),
                };
            }
            return workflowsLoader;
        }, (t) => t.id, (t, lang) => lang.updateTypes[t.updateTypeId] ?? t.updateType?.label ?? ''),
        displayGroup: (lang) => lang.caseFilter.workflowsGroup,
    },
    nextCaseWorkflowTask: {
        key: 'nextCaseWorkflowTask',
        label: (lang) => lang.viewFilterTypeLabels.nextCaseWorkflowTask,
        icon: 'workflow',
        picker: ListPicker('nextCaseWorkflowTask', 'cases.workflowNextTaskId', () => {
            const workflowsLoader = useWorkflows();
            const updateTypesLoader = useUpdateTypes();
            if (h.hasData(workflowsLoader)) {
                const updateTypeLookup = h.hasData(updateTypesLoader)
                    ? objectBy(updateTypesLoader.data, (ut) => ut.updateTypeId)
                    : {};
                return {
                    ...workflowsLoader,
                    data: uniqueBy(workflowsLoader.data.flatMap((wf) => wf.tasks.map((t) => ({
                        ...t,
                        updateType: updateTypeLookup[t.updateTypeId] ?? undefined,
                    }))), (t) => t.id),
                };
            }
            return workflowsLoader;
        }, (t) => t.id, (t, lang) => lang.updateTypes[t.updateTypeId] ?? t.updateType?.label ?? ''),
        typePicker: InFilterTypePicker,
        display: ListDisplay(() => {
            const workflowsLoader = useWorkflows();
            const updateTypesLoader = useUpdateTypes();
            if (h.hasData(workflowsLoader)) {
                const updateTypeLookup = h.hasData(updateTypesLoader)
                    ? objectBy(updateTypesLoader.data, (ut) => ut.updateTypeId)
                    : {};
                return {
                    ...workflowsLoader,
                    data: uniqueBy(workflowsLoader.data.flatMap((wf) => wf.tasks.map((t) => ({
                        ...t,
                        updateType: updateTypeLookup[t.updateTypeId] ?? undefined,
                    }))), (t) => t.id),
                };
            }
            return workflowsLoader;
        }, (t) => t.id, (t, lang) => lang.updateTypes[t.updateTypeId] ?? t.updateType?.label ?? ''),
        displayGroup: (lang) => lang.caseFilter.workflowsGroup,
    },
    caseStatusTime: {
        key: 'caseStatusTime',
        label: (lang) => lang.viewFilterTypeLabels.caseStatusTime,
        icon: 'calendar',
        picker: DatePicker('caseStatusTime', 'cases.statusTime'),
        typePicker: DateFilterTypePicker,
        display: DateDisplay('cases.statusTime'),
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    caseNumbers: {
        key: 'caseNumbers',
        label: (lang) => lang.viewFilterTypeLabels.caseNumbers,
        icon: 'list',
        omitSearch: true,
        picker: InputListPicker('caseNumbers', 'cases.id', 'int'),
        typePicker: InFilterTypePicker,
        display: InputListDisplay,
        displayGroup: (lang) => lang.caseFilter.casesGroup,
    },
    property: {
        key: 'property',
        label: (lang) => lang.viewFilterTypeLabels.properties,
        icon: 'custom',
        omitSearch: true,
        picker: PropertyPicker,
        typePicker: NotImplementedFilterTypePicker,
        display: PropertyDisplay,
        displayGroup: (lang) => lang.caseFilter.properties,
    },
    caseResponsible: {
        key: 'caseResponsible',
        label: (lang) => lang.viewLabels.caseResponsible,
        icon: 'user',
        omitSearch: false,
        picker: ListPicker('caseResponsible', 'cases.responsibleReferenceId', () => {
            const usersLoader = useUsers();
            const teamsLoader = useTeams();
            if (h.hasData(usersLoader) && h.hasData(teamsLoader)) {
                return {
                    ...teamsLoader,
                    data: [
                        ...teamsLoader.data,
                        ...usersLoader.data.filter((u) => u.tenant.role === 'caseworker' || u.tenant.role === 'admin'),
                    ],
                };
            }
            return teamsLoader;
        }, (t) => t.id, (t, lang) => ('name' in t ? t.name : `${t.firstName} ${t.lastName}`), (t) => ('name' in t ? 'users' : 'user')),
        typePicker: InFilterTypePicker,
        display: ListDisplay(() => {
            const usersLoader = useUsers();
            const teamsLoader = useTeams();
            if (h.hasData(usersLoader) && h.hasData(teamsLoader)) {
                return {
                    ...teamsLoader,
                    data: [
                        ...teamsLoader.data,
                        ...usersLoader.data
                            .filter((u) => u.tenant.role === 'caseworker' || u.tenant.role === 'admin')
                            .filter((u) => u.state !== UserState.DELETED),
                    ],
                };
            }
            return teamsLoader;
        }, (t) => t.id, (t, lang) => ('name' in t ? t.name : `${t.firstName} ${t.lastName}`)),
        displayGroup: (lang) => lang.caseFilter.updatesGroup,
    },
};
export const availableFilters = {
    cases: [
        'caseStatus',
        'caseStatusTime',
        'caseCreatedAt',
        'caseNumbers',
        'caseGroupId',
        'endReasonId',
        'creditorId',
        'pausedWithUpdates',
        'historicallyPausedUpdates',
        'interactionType',
        'interactionDirection',
        'interactionCreatedAt',
        'caseVoucherType',
        'caseVoucherDate',
        'caseVoucherExpirationDate',
        'billingModelId',
        'documentType',
        'caseWorkflow',
        'currentCaseWorkflowTask',
        'nextCaseWorkflowTask',
        'property',
        'caseResponsible',
    ],
    creditors: ['creditorId', 'creditorState', 'creditorCreatedAt'],
    caseVouchers: [
        'caseVoucherDate',
        'caseVoucherState',
        'caseVoucherSource',
        'caseVoucherCurrency',
        'caseVoucherCreatedAt',
        'caseVoucherExpirationDate',
        'caseVoucherIrrecoverableDate',
        'caseVoucherType',
    ],
};
//# sourceMappingURL=filter-options.js.map